module.exports = __webpack_public_path__ + "img/logo-wordmark-white.0d31a3d.svg";